export interface Movie {
  id: string;
  title: string;
  year: number;
  type: '电影' | '电视剧' | '纪录片';
  region: string;
  rating: number;
  director: string;
  cast: string[];
  cover: string;
  summary: string;
  tags: string[];
  actors: { name: string; role: string; photo: string }[];
}

export const movies: Movie[] = [
  {
    id: 'titanic-1997',
    title: '泰坦尼克号',
    year: 1997,
    type: '电影',
    region: '美国',
    rating: 9.4,
    director: '詹姆斯·卡梅隆',
    cast: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    cover: 'https://readdy.ai/api/search-image?query=Majestic%20vintage%20ocean%20liner%20ship%20at%20sunset%20on%20deep%20navy%20blue%20ocean%2C%20romantic%20cinematic%20poster%20style%2C%20golden%20warm%20light%20accents%2C%20elegant%20classic%20film%20atmosphere%2C%20dramatic%20sky%20with%20soft%20clouds%2C%20high%20detail%20painterly%20style&width=800&height=1120&seq=titanic-cover-01&orientation=portrait',
    summary: '1912年，豪华邮轮泰坦尼克号在处女航中撞上冰山沉没，杰克与露丝在这场灾难中相遇相爱，谱写了一段跨越阶级的动人爱情故事。',
    tags: ['爱情', '灾难', '经典'],
    actors: [
      { name: '莱昂纳多·迪卡普里奥', role: '杰克·道森', photo: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20handsome%20male%20actor%20in%20vintage%201910s%20style%20suit%2C%20warm%20studio%20lighting%2C%20deep%20navy%20background%2C%20elegant%20classic%20cinematic%20portrait%20photography&width=400&height=400&seq=actor-leo-01&orientation=squarish' },
      { name: '凯特·温斯莱特', role: '露丝·德威特·布克特', photo: 'https://readdy.ai/api/search-image?query=Portrait%20of%20elegant%20young%20female%20actor%20in%20vintage%201910s%20dress%20with%20upswept%20hair%2C%20warm%20golden%20studio%20lighting%2C%20deep%20navy%20background%2C%20classic%20cinematic%20portrait%20photography&width=400&height=400&seq=actor-kate-01&orientation=squarish' },
    ],
  },
  {
    id: 'titanic-blood-and-steel',
    title: '泰坦尼克号：血与钢',
    year: 2012,
    type: '电视剧',
    region: '英国',
    rating: 7.8,
    director: 'Ciaran Donnelly',
    cast: ['凯文·扎加里', '阿利桑德罗·索利克', '斯蒂芬妮·伦纳德'],
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20shipyard%20scene%20with%20giant%20steel%20hull%20under%20construction%2C%20deep%20navy%20blue%20tones%2C%20industrial%20atmosphere%2C%20warm%20golden%20rim%20light%2C%20cinematic%20period%20drama%20poster%20style&width=800&height=1120&seq=titanic-cover-02&orientation=portrait',
    summary: '讲述泰坦尼克号从设计建造到最终竣工的幕后故事，展现造船工人、工程师与企业家之间错综复杂的命运纠葛。',
    tags: ['历史', '剧情'],
    actors: [
      { name: '凯文·扎加里', role: '马克·穆尔', photo: 'https://readdy.ai/api/search-image?query=Portrait%20of%20rugged%20male%20actor%20in%20early%201900s%20shipyard%20worker%20outfit%2C%20warm%20dramatic%20lighting%2C%20deep%20navy%20blue%20background%2C%20classic%20period%20drama%20portrait&width=400&height=400&seq=actor-kevin-01&orientation=squarish' },
    ],
  },
  {
    id: 'last-mysteries-of-titanic',
    title: '泰坦尼克号的最后秘密',
    year: 2005,
    type: '纪录片',
    region: '美国',
    rating: 8.6,
    director: 'James Cameron',
    cast: ['詹姆斯·卡梅隆'],
    cover: 'https://readdy.ai/api/search-image?query=Underwater%20shipwreck%20documentary%20scene%20with%20deep%20sea%20submarine%20lights%20illuminating%20rusted%20hull%2C%20deep%20navy%20blue%20underwater%20atmosphere%2C%20golden%20spotlight%20accents%2C%20cinematic%20documentary%20poster%20style&width=800&height=1120&seq=titanic-cover-03&orientation=portrait',
    summary: '导演詹姆斯·卡梅隆亲自带队深海探索泰坦尼克号残骸，揭开沉船内部结构与沉没瞬间的诸多未解之谜。',
    tags: ['探索', '历史', '科学'],
    actors: [
      { name: '詹姆斯·卡梅隆', role: '探索队长', photo: 'https://readdy.ai/api/search-image?query=Portrait%20of%20documentary%20director%20in%20expedition%20gear%2C%20confident%20expression%2C%20deep%20navy%20blue%20studio%20background%2C%20warm%20golden%20rim%20lighting%2C%20cinematic%20portrait&width=400&height=400&seq=actor-cameron-01&orientation=squarish' },
    ],
  },
  {
    id: 'titanic-musical',
    title: '泰坦尼克号：音乐剧电影版',
    year: 2001,
    type: '电影',
    region: '英国',
    rating: 7.5,
    director: 'Richard Jones',
    cast: ['大卫·加里森', '布莱恩·达西·詹姆斯'],
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20grand%20ballroom%20stage%20scene%20with%20orchestra%20and%20period%20costumes%2C%20deep%20navy%20blue%20curtain%20backdrop%2C%20golden%20stage%20lighting%2C%20musical%20theater%20cinematic%20poster&width=800&height=1120&seq=titanic-cover-04&orientation=portrait',
    summary: '改编自百老汇同名音乐剧，以歌声与舞台叙事方式重现泰坦尼克号上形形色色乘客的故事与命运交织。',
    tags: ['音乐', '剧情', '经典'],
    actors: [
      { name: '大卫·加里森', role: '布鲁斯·伊斯梅', photo: 'https://readdy.ai/api/search-image?query=Portrait%20of%20distinguished%20older%20male%20actor%20in%20formal%20Edwardian%20suit%2C%20theatrical%20warm%20lighting%2C%20deep%20navy%20blue%20background%2C%20classic%20portrait%20photography&width=400&height=400&seq=actor-david-01&orientation=squarish' },
    ],
  },
  {
    id: 'titanic-honor-and-glory',
    title: '泰坦尼克号：荣耀与沉没',
    year: 2018,
    type: '纪录片',
    region: '加拿大',
    rating: 8.2,
    director: 'Parks Stephenson',
    cast: ['帕克斯·史蒂芬森'],
    cover: 'https://readdy.ai/api/search-image?query=Historic%20archival%20style%20scene%20of%20grand%20ocean%20liner%20departing%20harbor%2C%20deep%20navy%20blue%20toned%20vintage%20photograph%20look%2C%20golden%20light%20accents%2C%20documentary%20cinematic%20poster&width=800&height=1120&seq=titanic-cover-05&orientation=portrait',
    summary: '通过珍贵历史影像与专家访谈，全面还原泰坦尼克号从建造、首航到沉没的完整历史脉络。',
    tags: ['历史', '纪实'],
    actors: [
      { name: '帕克斯·史蒂芬森', role: '历史学家', photo: 'https://readdy.ai/api/search-image?query=Portrait%20of%20historian%20expert%20in%20smart%20casual%20attire%2C%20thoughtful%20expression%2C%20deep%20navy%20blue%20background%2C%20warm%20golden%20lighting%2C%20documentary%20portrait%20style&width=400&height=400&seq=actor-parks-01&orientation=squarish' },
    ],
  },
  {
    id: 'titanic-survivors',
    title: '泰坦尼克号幸存者口述史',
    year: 2010,
    type: '电视剧',
    region: '美国',
    rating: 8.0,
    director: 'Nancy Porter',
    cast: ['多位幸存者后代'],
    cover: 'https://readdy.ai/api/search-image?query=Vintage%20lifeboat%20scene%20on%20calm%20dark%20ocean%20at%20dawn%2C%20survivors%20silhouette%2C%20deep%20navy%20blue%20tones%2C%20warm%20golden%20horizon%20light%2C%20emotional%20cinematic%20poster%20style&width=800&height=1120&seq=titanic-cover-06&orientation=portrait',
    summary: '采访泰坦尼克号幸存者的后代，还原家族记忆中那场灾难之夜的真实细节与情感冲击。',
    tags: ['历史', '访谈', '情感'],
    actors: [],
  },
];